import styled from "styled-components";

export const LevelContainer = styled.div`
  display: ${(props) => (props.show ? "flex !important" : "none")};
  justify-content: center;
  align-items: center;
  overflow: hidden;
  height: 100vh;
  width: 100vw;
`;

export const TilesContainer = styled.div`
  width: 300px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* box-shadow: 0 32px 64px 0 rgba(0, 0, 0, 0.09),
    inset 0 -5px 0 0 rgba(0, 0, 0, 0.5); */
  background-color: rgba(210, 229, 255, 0.11);
  padding: 30px;
  border-radius: 10px;
  @media screen and (max-width: 425px) {
    width: 150px;
    height: 150px;
  }
  @media screen and (min-width: 425) and (max-width: 768px) {
    width: 200px;
    height: 200px;
  }
`;

export const InnerTilesContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #1d1d1d;
`;
